import { normalizeShopDomain } from "./shopDomain";

function shopHandleFromDomain(shop) {
  const domain = normalizeShopDomain(shop);
  if (!domain) return "";
  return domain.replace(/\.myshopify\.com$/i, "");
}

/** Shopify Admin → Settings → Shipping and delivery */
export function getShopifyAdminShippingSettingsUrl(shop) {
  const handle = shopHandleFromDomain(shop);
  if (!handle) {
    return "https://admin.shopify.com/settings/shipping";
  }
  return `https://admin.shopify.com/store/${encodeURIComponent(handle)}/settings/shipping`;
}
